// const mxModule = require("mxgraph")();
// const { mxCylinder, mxPoint, mxConnectionConstraint } = mxModule;

import { mxCylinder, mxPoint, mxConnectionConstraint } from "../utils/graph/mxModule";

function inputOutputPinShape() {}

inputOutputPinShape.prototype = new mxCylinder();
inputOutputPinShape.prototype.constructor = inputOutputPinShape;

inputOutputPinShape.prototype.constraints = [
  new mxConnectionConstraint(new mxPoint(0.5, 0.5), false)
];

inputOutputPinShape.prototype.paintVertexShape = function (c, x, y, w, h) {
  const dx = w / 80;
  const dy = h / 40;

  c.setStrokeColor("green");
  c.setFillColor("red");
  c.setStrokeWidth(1);

  c.begin();
  c.moveTo(x + dx * 0,  y + dy * 20);
  c.lineTo(x + dx * 20, y + dy * 0);
  c.lineTo(x + dx * 60, y + dy * 0);
  c.lineTo(x + dx * 80, y + dy * 20);
  c.lineTo(x + dx * 60, y + dy * 40);
  c.lineTo(x + dx * 20, y + dy * 40);
  c.close();

  c.fillAndStroke();
};

export default inputOutputPinShape;
